import type { ReactNode } from 'react';

type Props = {
  eyebrow?: string;
  title: string;
  children?: ReactNode;
  align?: 'left' | 'center';
};

export function SectionHeading({ eyebrow, title, children, align = 'left' }: Props) {
  return (
    <div className={align === 'center' ? 'mx-auto max-w-3xl text-center' : 'max-w-3xl'}>
      {eyebrow && <p className="text-xs font-black uppercase tracking-[0.18em] text-gold sm:text-sm sm:tracking-[0.24em]">{eyebrow}</p>}
      <h2 className="mt-3 text-3xl font-black leading-tight tracking-[-0.035em] text-ink sm:text-4xl lg:text-5xl">{title}</h2>
      {children && <div className="mt-5 text-base leading-7 text-charcoal/75 sm:text-lg sm:leading-8">{children}</div>}
    </div>
  );
}
